import { isStringEnumValue } from 'utils';
import { LanguageOption, PendingChangeType } from './types';

export const languageOptions: LanguageOption[] = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'Chinese (Simplified)', value: 'zhCN' },
  { label: 'Chinese (Traditional)', value: 'zhTW' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Polish', value: 'pl' },
  { label: 'Russian', value: 'ru' },
];
export const defaultLanguage = languageOptions[0];

export const resolveChangeType = (changeType: string): PendingChangeType => {
  return isStringEnumValue(PendingChangeType, changeType) ? changeType : null;
};
